import axios from '../../../services/axios';

const BASE_API_URL = import.meta.env.VITE_APP_API_URL;

export const deleteResourceMapping = async (body: any) => {
  try {
    const response = await axios.request({
      method: 'DELETE',
      url: `${BASE_API_URL}/valet/v1/resource_mapping`,
      params: body,
    });
    return response.data;
  } catch (err: any) {
    console.error('deleteResourceMapping error:', err);
  }
};
